import React from "react";
import { connect } from "react-redux";
import { Button } from "ui-components";

import { updateNavStep } from "@workerhome/components/Sidebar/actions";
import { toggleDialog } from "@workerhome/components/App/actions";
import { NavigationWrapper } from "@common/styled/navigation";

class Navigation extends React.Component {
  /**
   * Determine new navigation properties and update the store
   * @param  {string} direction Navigation direction
   */
  onStepClick = direction => {
    const newStepsMeta = Object.assign({}, this.props.stepsMeta);
    const curStepsMeta = this.props.stepsMeta;

    let newSubStepIdx = curStepsMeta.activeSubStep;

    switch (direction) {
      case "next":
        newSubStepIdx++;
        break;
      case "prev":
        if (--newSubStepIdx < 0) {
          newSubStepIdx = 0;
        }
        break;
      default:
        break;
    }

    // Update the new object
    newStepsMeta.activeSubStep = newSubStepIdx;

    this.props.updateNavStep(newStepsMeta);
  };

  /**
   * Display the Assessment Complete dialog when indicated
   */
  onCompleteClick = () => {
    this.props.toggleDialog("Completion", true);
  };

  onAddActionsClick = () => {
    this.props.toggleDialog("Appendix", true);
  };

  /**
   * Generate the applicable Navigation bar buttons
   * @return {array} List of Navigation bar buttons
   */
  renderButtons = () => {
    // Store navigation values for easier understanding (in the following logic)
    const subsectionsCount = this.props.sectionsCount;
    const curStepsMeta = this.props.stepsMeta;
    const isFirstSubStep = curStepsMeta.activeSubStep === 0;
    const isLastSubStep = curStepsMeta.activeSubStep >= subsectionsCount - 1;

    let buttons = [];

    // Prompt the user to add suggested/specific tips
    buttons.push(
      <Button
        key="risk_indicator"
        medium
        disabled={!this.props.isRiskIndicated}
        onClick={this.onAddActionsClick}
      >
        Add Actions
      </Button>
    );

    // Display the "Next" button on all but the last step
    if (!isLastSubStep) {
      // "Next" should only be available after the section is complete
      buttons.push(
        <Button
          key="next"
          medium
          disabled={!this.props.isSectionComplete}
          onClick={() => this.onStepClick("next")}
        >
          Next
        </Button>
      );
    } else {
      // "Complete" should only be available after the section is complete
      buttons.push(
        <Button
          key="complete"
          medium
          disabled={!this.props.isSectionComplete}
          onClick={this.onCompleteClick}
        >
          Complete
        </Button>
      );
    }

    // Display the "Previous" button on all but the first step
    if (!isFirstSubStep) {
      buttons.unshift(
        <Button
          key="prev"
          secondary
          medium
          onClick={() => this.onStepClick("prev")}
        >
          Previous
        </Button>
      );
    }

    return buttons;
  };

  /**
   * Render the Navigation component
   * @return {object} Rendered Navigation component
   */
  render() {
    return (
      <NavigationWrapper>
        {this.renderButtons()}
      </NavigationWrapper>
    );
  }
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.workerHome.sidebar.stepsMeta,
    sectionsCount: store.workerHome.app.subsections.length
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateNavStep: direction => dispatch(updateNavStep(direction)),
    toggleDialog: (dialog, isShown) => dispatch(toggleDialog(dialog, isShown))
  };
}

const NavigationContainer = connect(mapStateToProps, mapDispatchToProps)(
  Navigation
);
export default NavigationContainer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/Navigation/NavigationContainer.jsx